export default function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-scale/src/colors.js
// module id = ../../../../d3-scale/src/colors.js
// module chunks = 4